// Sales routes (under accounting app)
import SalesHome from "@/views/sales/SalesHome.vue";
import SalesMonthly from "@/views/sales/SalesMonthly.vue";
import SalesRawData from "@/views/sales/SalesRawData.vue";
import SalesMonthlyAverages from "@/views/sales/SalesMonthlyAverages.vue";
import SalesDaily from "@/views/sales/SalesDaily.vue";
import DailySalesChart from "@/views/sales/charts/DailySalesChart.vue";
import MonthlySalesChart from "@/views/sales/charts/MonthlySalesChart.vue";

const routes = [
  {
    path: "/accounting/sales",
    name: "SalesHome",
    component: SalesHome,
    meta: { requiresAuth: true, app: ["sales", "accounting"] },
  },
  {
    path: "/accounting/sales/charts/daily",
    name: "DailySalesChart",
    component: DailySalesChart,
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
  {
    path: "/accounting/sales/charts/monthly",
    name: "MonthlySalesChart",
    component: MonthlySalesChart,
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
  {
    path: "/accounting/sales/charts/monthly-averages",
    name: "MonthlyAveragesChart",
    component: () => import("@/views/sales/charts/MonthlyAveragesChart.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
  {
    path: "/accounting/sales/monthly",
    name: "SalesMonthly",
    component: SalesMonthly,
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
  {
    path: "/accounting/sales/monthly-averages",
    name: "SalesMonthlyAverages",
    component: SalesMonthlyAverages,
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
  {
    path: "/accounting/sales/daily",
    name: "SalesDaily",
    component: SalesDaily,
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
  {
    path: "/accounting/sales/analytics",
    name: "SalesAnalytics",
    component: () => import("@/views/sales/SalesAnalytics.vue"),
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
  {
    path: "/accounting/sales/raw-data",
    name: "SalesRawData",
    component: SalesRawData,
    meta: { requiresAuth: true, requiresAdmin: true, app: ["sales", "accounting"] },
  },
];

export default routes;
